const success = {
    passwordResetRequest: 'Die Anfrage wurde durchgeführt',
    requestSent: 'Anfrage wurde versendet.',
    supportFormSent: 'Supportanfrage wurde versendet',
    resetRequest: 'Anfrage wurde versendet'
}

export default success
